import React from 'react';
import { Tab, Row, Col, Panel } from 'react-bootstrap';
import PropTypes from 'prop-types';
import {
  BrowserRouter as Router,
  Switch,
  Route
} from 'react-router-dom';

import {
  faClipboard,
  faServer,
  faHome,
  faBullhorn,
  faEdit,
  faLocationArrow
} from '@fortawesome/pro-solid-svg-icons';

import ProjectLayout from 'components/project_layout/project_layout';
import LayoutHeader from 'components/project_layout/layout_header';
import ProjectCard from 'components/project/project_card';
import ActivityCard from 'components/project/activity_card';

const TABS = {
  workspace: {
    icon: faServer,
    subtabs: {
      'overview': {
        icon: faHome,
      },
      'notes': {
        icon: faEdit,
      }
    }
  },
  sample: {
    icon: faBullhorn,
    subtabs: {
      'subtab1': {
        icon: faClipboard,
        label: 'Subtab One'
      },
      'subtab2': {
        icon: faLocationArrow,
        label: 'Subtab Two'
      }
    }
  }
};

export default class ProjectSample extends React.Component {
  static propTypes = {
    styleGuidePath: PropTypes.string.isRequired
  }

  state = {
    activeTab: null
  }

  moveToTab = (key) => {
    this.setState({ activeTab: key });
  }

  renderTabContent() {
    return (
      <div className="container-fluid py-4">
        <Switch>
          <Route path="/overview">
            <Row>
              <Col md={6}>
                <ProjectCard
                  name="Card Sample"
                  pillLabelText="5 / 5 stars"
                  rightActionText={'SOME ACTION'}
                  onRightAction={() => false}
                >
                  <Panel.Body>
                    <p>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut
                      labore et dolore magna aliqua. Sed vulputate mi sit amet. Enim facilisis gravida neque
                      convallis a. Et malesuada fames ac turpis egestas maecenas pharetra convallis.
                      Eget mauris pharetra et ultrices neque. Auctor elit sed vulputate mi sit amet mauris commodo.
                    </p>
                    <p>
                      Nibh cras pulvinar mattis nunc sed blandit libero. Adipiscing elit pellentesque habitant morbi
                      tristique senectus. Quam pellentesque nec nam aliquam sem et tortor consequat id. Nunc
                      scelerisque viverra mauris in aliquam sem fringilla. Posuere sollicitudin aliquam ultrices
                      sagittis orci a. At in tellus integer feugiat. Quam elementum pulvinar etiam non. Ipsum dolor
                      sit amet consectetur adipiscing elit duis.
                    </p>
                  </Panel.Body>
                </ProjectCard>
              </Col>
              <Col md={6}>
                <ActivityCard
                  activityType="email"
                  associatedModels={[{
                    name: 'Paul Simon'
                  }]}
                  author="Tara Schoessel"
                  authorImageUrl="/images/default-profile-photo.png"
                  body="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut
                    labore et dolore magna aliqua. Sed vulputate mi sit amet. Enim facilisis gravida neque
                    convallis a. Et malesuada fames ac turpis egestas maecenas pharetra convallis.
                    Eget mauris pharetra et ultrices neque. Auctor elit sed vulputate mi sit amet mauris commodo."
                  pinned={true}
                  timestamp="2019-07-19T07:00"
                  title="Lorem ipsum dolor sit amet"
                >
                </ActivityCard>
              </Col>
            </Row>
          </Route>
          <Route path="/notes">
            <h1>Notes</h1>
          </Route>
          <Route path="/tasks">
            <h1>Tasks</h1>
          </Route>
          <Route path="/subtab1">
            <h1>Sample Subtab the First</h1>
          </Route>
          <Route path="/subtab2">
            <h1>Sample Subtab the Second</h1>
          </Route>
        </Switch>
      </div>
    );
  }

  render() {
    const collaborators = [{
      id: 1,
      imageUrl: 'https://s3.amazonaws.com/buildout-production/brandings/3084/assets/3160/original.png?1558380488',
      name: 'John Doe',
      role: 'Broker'
    }, {
      id: 2,
      imageUrl: 'https://s3.amazonaws.com/buildout-production/brandings/3084/assets/3160/original.png?1558380488',
      name: 'Jane Doe',
      role: 'Broker'
    }];

    return (
      <Router basename="/style_guide/react_projects">
        <div className="project-wrapper">
          <LayoutHeader
            collaborators={collaborators}
            status="On Market"
            subtitle="1234 Main St, Chicago, IL 60606"
            thumbnailUrl="https://s3.amazonaws.com/buildout-production/brandings/3084/assets/3161/original.jpg"
            title="The Mobi Building"
          >
            <a className="btn btn-dark" href={this.props.styleGuidePath}>
              Back to Style Guide
            </a>
          </LayoutHeader>
          <ProjectLayout
            activeTab={this.state.activeTab}
            tabs={TABS}
            onTabChanged={this.moveToTab}
          >
            {this.renderTabContent()}
          </ProjectLayout>
        </div>
      </Router>
    );
  }
}
